<template>
  <div class="mt-4 pr-0 pl-0 pt-2 border_all" style="border: thin solid rgba(0,0,0,.12)">
    <v-card elevation="0" class="mb-10">
      <v-card-title>
        Pengaturan Transaksi
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" lg="4">
            <!--          <div class="mt-6">-->
            <!--            <v-select-->
            <!--                label="Jenis API"-->
            <!--                item-text="name"-->
            <!--                item-value="id"-->
            <!--                v-model="jenisapi"-->
            <!--                :items="jenisapis"-->
            <!--                return-object-->
            <!--            ></v-select>-->
            <!--          </div>-->
            <div><v-text-field v-model="sellerapi.userid" label="UserID"></v-text-field></div>
            <div><v-text-field type="password" v-model="sellerapi.pin" label="PIN"></v-text-field></div>
            <div><v-text-field type="password" v-model="sellerapi.username" label="UserName"></v-text-field></div>
            <div><v-text-field type="password" v-model="sellerapi.password" label="Password"></v-text-field></div>
            <div><v-text-field v-model="sellerapi.apiurl" label="Api URL"></v-text-field></div>
          </v-col>
          <v-col cols="12" lg="8" md="8">
            <div class="pa-4" style="height: 100%;background-color:#fafafa;border: 1px dashed #d9d9d9;">
              {{apitestresult}}
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-btn class="mr-2" color="accent" @click="doAPITest(sellerapi)">Test</v-btn>
        <v-btn elevation="0" @click="simpan" color="primary"><v-icon>save</v-icon>Simpan</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'SettingApiJual',
  data: () => ({
    jenisapi: 0,
    jenisapis: [
      { id: 0, name: 'Standar HTTP GET' },
      { id: 1, name: 'IRS' },
      { id: 2, name: 'OTOMAX' }
    ]
  }),
  mounted () {
    this.getSellerAPI()
  },
  computed: {
    ...mapState('SellerStore', ['sellerapi', 'apitestresult'])
  },
  methods: {
    ...mapActions('SellerStore', ['doAPITest', 'getSellerAPI', 'setSellerAPI']),
    simpan () {
      this.setSellerAPI(this.sellerapi)
    }
  }
}
</script>

<style scoped>

</style>
